import Typography from '@components/common/typography';
import CardsSection from '@sections/xeppt_cards/cards';
import styles from './styles.module.scss';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import Button from '@components/common/button';
import { routes } from '@const/routes';
import { useNavigationContext } from '@hooks/context/useNavigationContext';
import { useLocales } from '@hooks/helpers/useLocales';

const XepptCardsLayout = () => {
    const { handleBack } = useNavigationContext();
    const { submitLocale } = useLocales();
    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <div className={styles.header}>
                <Button
                    className={styles.back}
                    leftIcon="arrow_left"
                    variant="text-gray"
                    onClick={() => {
                        handleBack(routes.send_and_request);
                    }}>
                    {submitLocale('back')}
                </Button>
                <Typography variant="h4">XEPPT cards</Typography>
            </div>
            <div className={styles.content}>
                <CardsSection />
            </div>
        </motion.div>
    );
};

export default XepptCardsLayout;
